module.exports = __webpack_public_path__ + "img/007-man.a24cb107.png";